import { CheckCircle2, File } from 'lucide-react';
import type { ReportStato } from '../../../api/apiTypes';

const STATUS_CONFIG: Record<ReportStato, { icon: React.ReactNode; label: string; textCls: string }> = {
  generated: { icon: <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />, label: 'Generato',     textCls: 'text-emerald-600' },
  drafted:   { icon: <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />, label: 'Generato',     textCls: 'text-emerald-600' },
  edited:    { icon: <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />, label: 'Generato',     textCls: 'text-emerald-600' },
  approved:  { icon: <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />, label: 'Generato',     textCls: 'text-emerald-600' },
  completed: { icon: <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />, label: 'Generato',     textCls: 'text-emerald-600' },
  empty:     { icon: <File         className="w-3.5 h-3.5 text-gray-400"    />, label: 'Da generare',  textCls: 'text-gray-400'    },
};

interface Props {
  status: ReportStato;
}

const DriverStatusBadge = ({ status }: Props) => {
  const cfg = STATUS_CONFIG[status];
  return (
    <span className="flex items-center gap-1.5">
      {cfg.icon}
      <span className={`text-xs font-medium ${cfg.textCls}`}>{cfg.label}</span>
    </span>
  );
};

export default DriverStatusBadge;
